import type { Transition } from "@uirouter/core";
import get from "lodash/get";

import { swSettings } from "app/common/services/swSettings";

export const isBenchmarkTrackerAllowed = (transition: Transition) => {
    const isAllowed = get(swSettings, "components.BenchmarkTracker.isAllowed", false) as boolean;
    const isDisabled = get(swSettings, "components.BenchmarkTracker.isDisabled", false) as boolean;

    const isBTAvailable = isAllowed && !isDisabled;

    if (!isBTAvailable) {
        return transition.router.stateService.target("activation-home");
    }
};
